import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WmsViewOnlyNotice = _resolveComponent("WmsViewOnlyNotice")!
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.readOnly)
      ? (_openBlock(), _createBlock(_component_WmsViewOnlyNotice, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
      _createVNode(_component_Search, {
        selectData: _ctx.filterOBject,
        filter: true,
        clearInput: true,
        clearInputSelect: true,
        showExport: false,
        showButton: !_ctx.readOnly,
        filterPlaceholder: 'message.SELECT',
        inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
        onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchHandler(1, Number(_ctx.routeParam)))),
        onReloadListing: _cache[2] || (_cache[2] = ($event: any) => (_ctx.get_price_group_products(1, false, null, null, Number(_ctx.routeParam)))),
        onExportFile: _ctx.exportFile
      }, null, 8, ["selectData", "showButton", "filterPlaceholder", "onExportFile"]),
      _createVNode(_component_Table, {
        columns: _ctx.columns,
        rows: _ctx.productsData,
        pagination: _ctx.pagination,
        padding: 3,
        onHandleCurrentChange: _ctx.handleCurrentChange,
        loading: _ctx.loader,
        onSorting: _ctx.searchHandler
      }, {
        "cell-name": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(JSON.parse(item.name.name)[`${_ctx.system_locale}`]?.name), 1)
        ]),
        "cell-sale_price": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.sale_price), 1)
        ]),
        "cell-special_price": _withCtx(({ row: item }) => [
          _createVNode("input", {
            type: "number",
            step: "any",
            class: "form-control position custom",
            value: item?.special_price,
            disabled: _ctx.readOnly || _ctx.isWmsRecord(item),
            title: _ctx.readOnly || _ctx.isWmsRecord(item) ? _ctx.$t('message.WMS_VIEW_ONLY') : '',
            onChange: ($event: any) => (
                        $event.target.value =
                            parseFloat($event.target.value) > 0
                                ? (parseFloat($event.target.value), _ctx.updatePosition(item?.special_price, parseFloat($event.target.value), item.product_id, item.price_group_id))
                                : item?.special_price
                    )
          }, null, 40, ["value", "disabled", "title", "onChange"])
        ]),
        _: 1
      }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading", "onSorting"])
    ])
  ], 64))
}